module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloading = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.register_client_popup_' + _vm.obj.licenseInfo.byod_type)))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type),
      "type": _vm.obj.newKeyValues.configurationId ? 'default' : 'is-danger'
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.obj.newKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "configurationId", $$v)
      },
      expression: "obj.newKeyValues.configurationId"
    }
  }, _vm._l((_vm.getFreeConfigurations(_vm.obj)), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.tag) + ": " + _vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', [_c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "1",
      "type": "is-danger"
    },
    model: {
      value: (_vm.obj.newKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "limitType", $$v)
      },
      expression: "obj.newKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.limited_by_datetime')) + "\n            ")])], 1), _vm._v(" "), _c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "2",
      "type": "is-info"
    },
    model: {
      value: (_vm.obj.newKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "limitType", $$v)
      },
      expression: "obj.newKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.unlimited_duration')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.obj.newKeyValues.limitType == 2) ? _c('div', {
    staticClass: "limit_type_2"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.check_frequency')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "max": "7",
        "icon": "clock",
        "placeholder": _vm.$t('index.days')
      },
      model: {
        value: (_vm.obj.newKeyValues.frequencyCheckPeriod),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "frequencyCheckPeriod", $$v)
        },
        expression: "obj.newKeyValues.frequencyCheckPeriod"
      }
    })], 1)]
  ], 2)])]) : _vm._e(), _vm._v(" "), (_vm.obj.newKeyValues.limitType == 1) ? _c('div', {
    staticClass: "limit_type_1"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeFrom($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeTo($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns session_block"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.session_time')))]), _vm._v(" "), _c('b-checkbox', {
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeOption", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeOption"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.custom_time_cb')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Default and max value 30days (43200 minutes)",
      "multilined": ""
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(!_vm.obj.newKeyValues.sessionTimeOption ? _vm.$t('index.default') : _vm.$t('index.custom_time')))])]), _vm._v(" "), (!_vm.obj.newKeyValues.sessionTimeOption) ? _c('div', [_c('b', [_vm._v("30 " + _vm._s(_vm.$t('index.days')))])]) : _c('div', [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "43200",
      "icon": "clock",
      "placeholder": _vm.$t('index.minutes')
    },
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeValue),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeValue", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeValue"
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.email')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "email",
      "icon": "envelope",
      "placeholder": _vm.$t('index.email')
    },
    model: {
      value: (_vm.obj.newKeyValues.email),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "email", $$v)
      },
      expression: "obj.newKeyValues.email"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.obj.licenseInfo.user_manage) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-checkbox', {
    attrs: {
      "disabled": !_vm.obj.newKeyValues.email
    },
    model: {
      value: (_vm.obj.newKeyValues.proLogin),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "proLogin", $$v)
      },
      expression: "obj.newKeyValues.proLogin"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.use_as_login')) + " ")])], 1)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.activation_panels_limit')
      }
    }, [_c('b-input', {
      attrs: {
        "placeholder": _vm.$t('index.activation_panels_limit_placeholder'),
        "type": "number",
        "min": "1",
        "icon": "clock"
      },
      model: {
        value: (_vm.obj.newKeyValues.activationsCount),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "activationsCount", $$v)
        },
        expression: "obj.newKeyValues.activationsCount"
      }
    })], 1)]
  ], 2)])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.addNewKey(_vm.objIndx, _vm.obj)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.register')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ad89b5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/mini_components/Registertoken.vue
// module id = 315
// module chunks = 2